import moment from 'moment'

import { formatBackendDateRange, i18nDateToString } from 'modules/core/lib/dates'

export const formatDateRange = (startDate: Date, endDate: Date): string => {
  const startDateStr = i18nDateToString(moment(startDate), 'backend')
  const endDateStr = i18nDateToString(moment(endDate), 'backend')
  const formatted = formatBackendDateRange(startDateStr, endDateStr)

  return formatted.replace(/—/g, '–').replace(/,/g, '')
}

export const generateDefaultTripName = (
  destinations: Array<{ locationName: string; locationData?: { locality?: string } }>,
  startDate: Date | null,
  endDate: Date | null
): string => {
  const validDestinations = destinations.filter((dest) => dest.locationName)

  if (validDestinations.length === 0) {
    return ''
  }

  const getName = (dest: { locationName: string; locationData?: { locality?: string } }) =>
    dest.locationData?.locality || dest.locationName

  const first = validDestinations.at(0)
  const last = validDestinations.at(-1)

  if (!first) return ''

  const destinationNames =
    last && last !== first ? `${getName(first)} - ${getName(last)}` : getName(first)

  if (!startDate || !endDate) {
    return destinationNames
  }

  const dateRange = formatDateRange(startDate, endDate)
  return `${destinationNames} · ${dateRange}`
}
